/**
 * When we delete an existing action of this type, we need to pass metadata for it.
 * When we update these actions, only Wait action requires metadata.
 * When Trickle action is updated, the waiting contacts get moved to the next action.
 */
export const METADATA_REQUIRED_ACTIONS = [
  'FlowV2_Action_Wait',
  'FlowV2_Action_Trickle',
];
